<div *ngIf="active"
  [ngClass]="{'active': active}">
  <ng-content></ng-content>
</div>
